var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_vm._m(0),_c('div',{staticClass:"sheetSet"},[_c('div',{staticClass:"left_slider"},[_c('left',{on:{"toSetIsMajor":_vm.toSetIsMajor,"toQueryList":_vm.toQueryList}})],1),_c('div',{staticClass:"right_slider"},[_c('right',{ref:"sheetSetRight"})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topTitle"},[_c('p',{staticClass:"title"},[_vm._v("图纸集")])])
}]

export { render, staticRenderFns }